import { useEffect, useRef, useState } from "react";
import { ArrowDownCircle } from "react-bootstrap-icons"
import { LoadScreenMin } from "./UI/LoadScreenMin"
import { format } from "date-fns";

export const HomeHeadVideoV = () => {

    const videoRef = useRef(null);
    const [isLoading, setIsloading] = useState()

    useEffect(() => {
        // Optional: Play the video automatically after preload if needed
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.addEventListener('loadeddata', () => {
                setTimeout(() => {
                    setIsloading(false)
                }, 2000)
            });
        }

        // Cleanup: Remove event listener on component unmount
        return () => {
            if (videoElement) {
                videoElement.removeEventListener('loadeddata', () => {
                    setIsloading(true)
                });
            }
        };
    }, []);

    return (
        <div className="position-relative main-intro-section">
            <div className="main-wrraper-section">
                {isLoading &&
                    <div style={{
                        position: "absolute",
                        width: "100%",
                        top: 0,
                        left: 0,
                    }}>
                        <LoadScreenMin height={100} />
                    </div>
                }
                <video ref={videoRef} className={"main-intro-video .main-intro-video-mobile"} autoPlay={true} playsInline={true} loop={true} muted={true} preload="none">
                    {/* <source src={`video/vertical.webm?`} type='video/webm' codecs="vp8, vorbis" /> */}
                    {/* <source src={`/api/redirecturls/vertikal`} type='video/webm' codecs="vp8, vorbis" /> */}
                    <source src={`https://leningradcenter.ru/api/redirecturls/vertical?${format(Date.now(),'ddHHmm')}`} type='video/mp4' />
                    {/* <source src={`/api/redirecturls/vertikal`} type='video/mp4' /> */}
                </video>
            </div>
            <div className="position-absolute continue-section" onClick={() => { window.scrollTo(0, window.innerHeight) }}>
                <div className="continue-arrow">
                    <ArrowDownCircle size={24} />
                </div>
            </div>

        </div>
    )
}